/* global $, query_string, data, pitch_types */
import * as d3 from 'd3'
import _ from 'underscore'
import Table from 'bam-node-savant-table/table'
import { getPitchTypeColor } from 'bam-node-baseball-savant/utils/pitch-type-colors'
import { normalizeAccents } from 'bam-node-baseball-savant/utils/normalize-accents'

const { guff } = require('bam-node-baseball-savant/utils/guff')

let parsedChartData = []
let scaleRadius
let pageWidth
let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'active_spin'

$(document).ready(() => {
    if (query_string.sortDir) {
        $('#sortDir').val(query_string.sortDir)
    }

    if (query_string.sort) {
        $('#sort').val(query_string.sort)
    }

    $('form').submit(false)

    if (data && data.length > 0) {
        parsedChartData = parseData(data)

        const secondaryHeaders = [
            {
                name: '',
                colspan: 4,
                headerClass: 'th-name-header',
            },
            {
                name: 'Active Spin (%)',
                colspan: 9,
                headerClass: 'th-title-header',
            },
        ]

        const headers = [
            {
                name: 'Pitcher',
                field: 'href',
                customSortField: 'name_display_last_first',
                headerClass:
                    'th-component-header align-left table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                photoId: 'pitcher',
            },
            {
                name: 'Team',
                field: 'team_id',
                headerClass: 'th-component-header align-center',
                fieldClass: 'tr-data align-center',
                photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" />',
                photoId: 'team_id',
                photoOnly: true,
            },
            {
                name: 'Throws',
                field: 'pitch_hand',
                headerClass: 'th-component-header',
                fieldClass: 'tr-data',
            },
        ]
        let name
        let value
        pitch_types.forEach((pt) => {
            if (pt.pitch_type_group === 'FF') {
                name = 'Four-Seam'
                value = `formatted_active_spin_fourseam`
            } else if (pt.pitch_type_group === 'FS') {
                name = 'Split-Finger'
                value = `formatted_active_spin_splitter`
            } else if (pt.pitch_type_group === 'CU') {
                name = 'Curveball'
                value = `formatted_active_spin_curve`
            } else {
                name = pt.pitch_name
                value = `formatted_active_spin_${pt.pitch_name.toLowerCase()}`
            }
            headers.push({
                name,
                field: value,
                type: 'number',
                headerClass: `th-component-header ${
                    name.toLowerCase() === 'four-seam' ? 'border-left' : ''
                } ${name.toLowerCase() === 'slurve' ? 'border-right' : ''}`,
                fieldClass: `tr-data ${
                    name.toLowerCase() === 'four-seam' ? 'border-left' : ''
                } ${name.toLowerCase() === 'slurve' ? 'border-right' : ''}`,
                displayFn: (val) => guff(val, 'active_spin_percent'),
            })
        })

        const width = $(`#${tableDivId}`).outerWidth()
        let repeatHeaders = false
        if (width <= 768) {
            repeatHeaders = 15
        }

        // eslint-disable-next-line no-new
        new Table({
            id: 'active_spin',
            headers,
            secondaryHeaders,
            data,
            defaultSort:
                headers[Number($('#sort').val())].customSortField ||
                headers[Number($('#sort').val())].field,
            defaultSortDirection: $('#sortDir').val(),
            sortClass: 'column-sort',
            repeatHeader: repeatHeaders,
            showRank: true,
        })
    } else {
        $('#NoData').html('<h1>No Data Found.</h2>')
    }

    window.addEventListener('scroll', () => {
        if (!ticking && data.length) {
            window.requestAnimationFrame(() => {
                checkHeaderPosition(tableDivId)
                ticking = false
            })

            ticking = true
        }
    })

    function checkHeaderPosition(divId) {
        const scrollPosY = window.scrollY
        const posTop = $(`#${divId}`).offset().top
        const height = $(`#${divId} table thead`).height()
        if (!isFixedHeaderShowing && posTop < scrollPosY) {
            isFixedHeaderShowing = true
            addStaticHeader(divId)
        } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
            $(`#${divId} table thead`).removeClass('fixed-header')
            isFixedHeaderShowing = false
        }
    }

    function addStaticHeader(divId) {
        const width = $(`#${divId}`).outerWidth()
        // $(".tr-component-row th").removeClass("column-sort");

        if (width && width > 767) {
            // console.log(width);
            let tableCell = 0

            // Set TH Width before applying fixed-header
            $(`#${divId} table tbody .default-table-row`)
                .first()
                .children('td')
                .each(function setTHWidth() {
                    const thWidth = $(this).outerWidth()
                    $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                        'width',
                        thWidth
                    )
                    tableCell += 1
                })

            $(`#${divId} table thead`).addClass('fixed-header')
            tableCell = 0

            // Set TD Width before applying fixed-header
            $(`#${divId} table thead .tr-component-row`)
                .children('th')
                .each(function setTDWidth() {
                    const tdWidth = $(this).outerWidth()
                    $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                        'width',
                        tdWidth
                    )
                    tableCell += 1
                })
        }
    }

    window.addEventListener('resize', () => {
        if (isFixedHeaderShowing) {
            addStaticHeader(tableDivId)
        }
    })

    $('#btnUpdate').click(() => {
        window.location.href = `/leaderboard/active-spin?year=${$(
            '#ddlSeason'
        ).val()}&min=${$('#ddlMin').val()}&hand=${$('#ddlHand').val()}`
    })
    $('#btnCSV').click(() => {
        window.location.href = `/leaderboard/active-spin?year=${$(
            '#ddlSeason'
        ).val()}&min=${$('#ddlMin').val()}&hand=${$('#ddlHand').val()}&csv=true`
    })

    $(document).on('click', 'th.th-component-header', function onClick() {
        const id = this.id.split('-')[1]

        if (Number($('#sort').val()) === Number(id)) {
            if ($('#sortDir').val() === 'desc') {
                $('#sortDir').val('asc')
            } else {
                $('#sortDir').val('desc')
            }
        } else {
            $('#sortDir').val('desc')
        }
        $('#sort').val(id)
        isFixedHeaderShowing = false
        checkHeaderPosition(tableDivId)
        populateUrl()
    })

    function populateUrl() {
        const url = `/leaderboard/active-spin?year=${$(
            '#ddlSeason'
        ).val()}&min=${$('#ddlMin').val()}&hand=${$('#ddlHand').val()}&sort=${$(
            '#sort'
        ).val()}&sortDir=${$('#sortDir').val()}`
        window.history.pushState('', '', url)
        return url
    }

    createChart(data)

    $('#txtPlayerSearch').keyup(function search() {
        if ($(this).val().length >= 3) {
            const player = $(this).val().toUpperCase()
            const playerSearch = _.filter(
                JSON.parse(JSON.stringify(data)),
                (d) =>
                    normalizeAccents(d.name_display_first_last)
                        .toUpperCase()
                        .indexOf(player) > -1
            )
            highlightPlayers(playerSearch)
        } else {
            d3.selectAll('.pitches')
                .attr('opacity', 1)
                .attr('r', scaleRadius(pageWidth))
            d3.selectAll('.tooltip').remove()
            // createChart(data);
        }
    })
})

function highlightPlayers(playerSearch) {
    d3.selectAll('.pitches').attr('opacity', 0.1)

    for (let i = 0; i < playerSearch.length; i++) {
        const p = playerSearch[i]
        d3.selectAll(`.pitcher_${p.pitcher}`)
            .attr('opacity', 1)
            .attr('r', scaleRadius(pageWidth) * 2)
    }

    if (playerSearch.length === 1) {
        loadToolTip(parsedChartData, playerSearch[0])
    } else {
        d3.selectAll('.tooltip').remove()
    }
}

function createChart(pageData) {
    d3.select('#svg_active_spin').remove()
    const chartData = parseData(pageData)

    pageWidth = $('#width').width()
    if (pageWidth >= 860) {
        pageWidth = 860
    }
    // set the dimensions and margins of the graph
    const margin = {
        top: pageWidth * 0.09,
        right: pageWidth * 0.09,
        bottom: pageWidth * 0.09,
        left: pageWidth * 0.09,
    }
    const width = pageWidth - margin.left - margin.right
    const height = pageWidth / 1.4 - margin.top - margin.bottom

    scaleRadius = d3.scaleLinear().domain([0, 300, 860]).range([1, 1, 3.5])

    // set the ranges
    const x = d3.scaleLinear().range([0, width])
    const y = d3.scaleLinear().range([height, 0])

    // append the svg obgect to the body of the page
    // appends a 'group' element to 'svg'
    // moves the 'group' element to the top left margin
    let svg = d3
        .select('#active-spin-chart')
        .append('svg')
        .attr('id', 'svg_active_spin')
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)

    svg.append('rect')
        .attr('width', '100%')
        .attr('height', '100%')
        .attr('fill', '#e4f2f5')

    svg = svg
        .append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`)

    svg.append('text')
        .attr('x', width / 2)
        .attr('y', -(margin.top / 2))
        .style('font-size', '1rem')
        .attr('text-anchor', 'middle')
        .text('Percent of Spin that Contributes to Movement by Release Speed')

    // Scale the range of the data
    x.domain(d3.extent(parsedChartData, (d) => Number(d.speed)))
    y.domain([d3.min(parsedChartData, (d) => Number(d.activeSpin)), 100])

    // Add the scatterplot
    svg.selectAll('dot')
        .data(chartData)
        .enter()
        .append('circle')
        .attr(
            'class',
            (d) => `pitches pitcher_${d.pitcher} pitch_${d.pitchCode}`
        )
        .attr('r', scaleRadius(pageWidth))
        .attr('cx', (d) => x(Number(d.speed)))
        .attr('cy', (d) => y(Number(d.activeSpin)))
        .attr('fill', (d) => getPitchTypeColor([d.pitchCode], false))
        .attr('stroke', '#000')
        .on('mouseover', (event, d) => {
            d3.selectAll('.pitches').attr('opacity', 0.1)
            d3.selectAll(`.pitcher_${d.pitcher}`)
                .attr('opacity', 1)
                .attr('r', scaleRadius(pageWidth) * 2)

            loadToolTip(chartData, d)
        })
        .on('mouseout', (event, d) => {
            d3.selectAll('.pitches')
                .attr('opacity', 1)
                .attr('r', scaleRadius(pageWidth))
            d3.select(`#tooltip_${d.pitcher}`).style('opacity', 0)
            $(`#tooltip_${d.pitcher}`).hide()
            $(`#tooltip_${d.pitcher}`).remove()
        })

    // Add the X Axis
    svg.append('g')
        .attr('transform', `translate(0,${height})`)
        .call(
            d3
                .axisBottom(x)
                .tickFormat((d) => `${d} MPH`)
                .ticks(6)
        )

    // Add the Y Axis
    svg.append('g').call(
        d3
            .axisLeft(y)
            .tickFormat((d) => `${d}%`)
            .ticks(10)
    )

    svg.selectAll('legend')
        .data(pitch_types)
        .enter()
        .append('text')
        .attr('x', (d, i) =>
            i === 0
                ? pageWidth * 0.06
                : i * (pageWidth * 0.09) + pageWidth * 0.09
        )
        .attr('y', height + margin.bottom / 1.1)
        .attr('text-anchor', 'middle')
        .text((d) => d.pitch_name)
        .attr('fill', (d) => getPitchTypeColor(d.pitch_type_group, true))
        .on('mouseover', (event, d) => {
            d3.selectAll('.pitches').attr('opacity', 0.1)
            d3.selectAll(`.pitches.pitch_${d.pitch_type_group}`).attr(
                'opacity',
                1
            )
        })
        .on('mouseout', () => {
            d3.selectAll('.pitches').attr('opacity', 1)
        })
}

function loadToolTip(chartData, d) {
    const pitches = _.filter(chartData, (pitch) => pitch.pitcher === d.pitcher)

    const tooltip = d3
        .select('#active-spin-chart')
        .append('div')
        .attr('id', `tooltip_${d.pitcher}`)
        .attr('class', 'tooltip')
        .style('opacity', 1)
    const html =
        `<div style="text-align: left; width: 130px; line-height: 1.4rem;">` +
        `<div style="float: left; width: 70px;"><div class="player-image">` +
        `<img onError="this.onerror=null;this.src='https://content.mlb.com/images/headshots/current/60x60/generic.png';" src="https://content.mlb.com/images/headshots/current/60x60/${d.pitcher}.png" style="width: 40px" />` +
        `</div></div>` +
        `<div style="float: left; width: 130px; font-family: 'Roboto Condensed'; font-size: 14px;">` +
        `<b><span style=" font-size: 16px;">${
            d.name_display_first_last
        }</span></b><br/>${pitches
            .map((p) => `${p.pitchType}: ${p.activeSpin}%`)
            .join('<br/>')}<br/>` +
        `</div>`

    tooltip
        .html(html)
        .style('left', `${pageWidth * 0.09 + 10}px`)
        .style('top', `${pageWidth * 0.09}px`)
}

function parseData(json) {
    const chartData = []

    for (let i = 0; i < json.length; i++) {
        const p = json[i]
        pitch_types.forEach((pt) => {
            let nPitchType
            let activeSpinPitchType
            let speed
            if (pt.pitch_type_group === 'FF') {
                // Pitch types dropdown function labels FF as 4-Seam Fastball
                nPitchType = `n_fourseam`
                activeSpinPitchType = `formatted_active_spin_fourseam`
                speed = `speed_fourseam`
            } else if (pt.pitch_type_group === 'FS') {
                // Pitch types dropdown function labels FS as Split-Finger
                nPitchType = `n_splitter`
                activeSpinPitchType = `formatted_active_spin_splitter`
                speed = `speed_splitter`
            } else if (pt.pitch_type_group === 'CU') {
                // Pitch types dropdown function labels CU as Curveball
                nPitchType = `n_curve`
                activeSpinPitchType = `formatted_active_spin_curve`
                speed = `speed_curve`
            } else {
                nPitchType = `n_${pt.pitch_name.toLowerCase()}`
                activeSpinPitchType = `formatted_active_spin_${pt.pitch_name.toLowerCase()}`
                speed = `speed_${pt.pitch_name.toLowerCase()}`
            }
            if (Number(p[nPitchType]) > 0) {
                chartData.push({
                    pitcher: p.pitcher,
                    name_display_first_last: p.name_display_first_last,
                    pitchType: pt.pitch_name,
                    pitchCode: pt.pitch_type_group,
                    activeSpin: p[activeSpinPitchType],
                    speed: Number(p[speed]).toFixed(1),
                })
            }
        })
    }
    return chartData
}

document.querySelectorAll('#leaderboard .form-control').forEach((el) => {
    el.addEventListener('change', (e) => {
        const id = el.getAttribute('id')
        const type = id.slice(3)
        const { selectedIndex } = e.target
        document.querySelector(`.label-change-${type}`).innerText =
            e.target[selectedIndex].text
    })
})
